import React from "react";
import "./EvaluationPopup.css";
import { useNavigate } from "react-router-dom";
import EvaluationService from "../../Services/EvaluationService";
import secureLocalStorage from "react-secure-storage";
import DataParser from "../../utlits/Dataparser";

const EvaluationPopup = ({ data, onClose }) => {
  const navigate = useNavigate();

  const adminInfo = JSON.parse(secureLocalStorage.getItem("adminInfo"));
  const headId = adminInfo?.user?.userdata?.id;
  const companyId = adminInfo?.user?.userdata?.company_id;

  const { hasPending, hasPastPending, canSkip, screenBlocked } = data;

  const skipPayload = {
    head_id: headId,
    company_id: companyId,
    period_start: data.periodStart || "all",
    period_end: data.periodEnd || "all"
  };

  const handleEvaluateNow = async () => {
    if (!screenBlocked) {
      // Info modal: count as skip (user may not actually evaluate after navigating)
      try { await EvaluationService.skipEvaluation(skipPayload); } catch (_) {}
    }
    navigate(`/${DataParser.CompanyIdentifierRole()}/evaluation`);
    onClose();
  };

  const handleSkip = () => {
    EvaluationService.skipEvaluation(skipPayload).catch(() => {});
    onClose();
  };

  return (
    <div className={`evaluation-popup ${screenBlocked ? "screen-blocker" : ""}`}>
      <div className="popup-content">
        <h3>Performance Evaluation Pending</h3>
        <p>
          {hasPastPending
            ? "You have pending performance evaluations from past periods. These are mandatory and must be completed to continue."
            : "You have pending performance evaluations that require your attention."}
          {screenBlocked && !hasPastPending ? " Please complete them to continue using the system." : ""}
          {!screenBlocked ? " Kindly complete them at your earliest convenience." : ""}
        </p>

        <div style={{ display: "flex", justifyContent: "center", gap: "10px", flexWrap: "wrap" }}>
          <button className="eval-btn-primary" onClick={handleEvaluateNow}>
            Evaluate Now
          </button>
          {/* Skip is only available on the info modal (first 3 days), not on the blocker */}
          {!screenBlocked && (
            <button className="eval-btn-skip" onClick={handleSkip}>
              Skip
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default EvaluationPopup;
